import {Injectable} from '@angular/core';

@Injectable()
export class DataService {

    private _registros: any = {};

    constructor() {

    }

    set(keyOrObj, value?) {

        //Null delete key
        if (value == null) {
            if (typeof this._registros[keyOrObj] == 'undefined') return;

            delete this._registros[keyOrObj];

            return;
        }

        if (typeof keyOrObj == 'object') {
            for (let i in keyOrObj) {
                this._registros[i] = keyOrObj[i];
            }
        }
        else {
            this._registros[keyOrObj] = value;
        }

        return this;

    }

    get(key?) {

        if (typeof key == 'undefined') {
            return this._registros;
        }

        if (typeof this._registros[key] == 'undefined') {
            return null;
        }

        return this._registros[key];

    }

}



// WEBPACK FOOTER //
// ./src/providers/data-service.ts